import {observer} from 'mobx-react';
import React from 'react';
import {PromiseMessage} from '../../../../lib/components';
import {X3LevelStore} from '../X3LevelStore';

@observer
export class ReorderUnitsControls extends React.Component<{ store: X3LevelStore }> {
  render() {
    const {store} = this.props;

    if (store.reorder === null)
      return null;

    const reorder = store.reorder;
    const isPending = reorder.save?.isPending === true;

    return (<>
      <div className="row justify-content-end" key="reorder-actions">
        <div className="col-auto">
          <button type="button" className="btn btn-primary"
                  onClick={store.completeReorder}
                  disabled={isPending}>
            Save
          </button>
          <button type="button" className="btn btn-primary"
                  onClick={store.cancel}
                  disabled={isPending}>
            Cancel
          </button>
        </div>
      </div>

      <PromiseMessage label="Saving" state={reorder.save} align="right"/>
    </>);
  }
}
